import * as types from './actionTypes';

export const defaultState = {
  isLoading: false,
  data: [],
  error: null,
};

const topValidators = (state = defaultState, action) => {
  switch (action.type) {
    case types.GET_TOP_VALIDATORS_START:
      return {
        ...state,
        ...{
          isLoading: true,
        },
      };
    case types.GET_TOP_VALIDATORS_SUCCESS:
      return {
        ...state,
        ...{
          data: action.response,
          isLoading: false,
        },
      };
    case types.GET_TOP_VALIDATORS_ERROR:
      return {
        ...state,
        ...{
          error: action.error,
        },
      };

    default:
      return state;
  }
};

export default topValidators;
